import md5 from "blueimp-md5";

export function makeValidHTMLId(componentId: string): string {
    return `must-start-with-a-letter${md5(componentId)}`;
}
